export const validateEmail = (email: string) => {
  const emailRegex =
    // eslint-disable-next-line no-control-regex
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gim;
  return emailRegex.test(email);
};

export const validatePassword = (password: string) => {
  const passwordRegex = /^(?=.*?[A-Z])?(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])?.{8,}$/;
  return passwordRegex.test(password);
};

//matches two words exact assuming that this is a persons name
export const isValidName = (name: string) => {
  return name.split(' ').length > 1;
};

//matches an email
export const isEmail = (email: string) => {
  if (!email || email === undefined) return false;
  return email.match(/^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/gim);
};

//matches a phone number
export const isPhoneNumber = (phone: string) => {
  //WE WILL HAVE TO ACCOUNT FOR INTERNATIONAL NUMBERS SO RETURN TRUE FOR NOW
  // if (!phone || phone === undefined) return false;
  // if (!phone.toString().match(/^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/gim)) return false;
  return true;
};

//mathes a date of birth
export const isDate = (date: string) => {
  if (!date || date === undefined) return false;
  return true;
};

export const isValidGender = (gender: string) => {
  if (gender && gender !== '') {
    if (gender.length > 1) return false;
    else if (gender.toUpperCase() !== 'M' && gender.toUpperCase() !== 'F' && gender.toUpperCase() !== 'U') return false;
  }

  return true;
};

export const isValidFileType = (fileType: never, allowedFileTypes: []) => {
  if (!Array.isArray(allowedFileTypes)) return false;
  // verify file type
  return allowedFileTypes.includes(fileType) ? true : false;
};

export const isEmpty = (string: string) => {
  return !string || string === null || string === undefined || string === '';
};

export const parseJSON = (subject: string) => {
  try {
    return JSON.parse(subject);
  } catch (error) {
    return subject;
  }
};

export const isDev = () => {
  if (window.location.hostname.search('localhost') >= 0 || window.location.hostname.search('dev-') >= 0) return true;
  return false;
};
